export default __webpack_public_path__ + "static/media/language-logo.f910b4ff.svg";